import { isBrandAC, isBrandOV } from 'src/constants/main';
import { theme } from 'src/styles/theme';

export const getCategoriesArrowColor = () => {
    if (isBrandAC) return theme.colors.blue2;
    if (isBrandOV) return theme.colors.black;

    return theme.colors.primary;
};
